<template lang="pug">
  transition-group( tag="div" name="fade" )
    div(
      class="alert moonpull-alert"
      v-for="(flashMessage, key) in flashMessages"
      v-bind:key="`${key}-${flashMessage.msg}`"
      v-bind:class="`alert-${flashMessage.type}`"
    ) {{ flashMessage.msg }}
</template>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.moonpull-alert {
  position: fixed;
  top: 50px;
  left: calc(251px + 50%);
  transform: translateX(calc(-50% - 125.5px));
  z-index: 9999;
  text-align: center;
}
</style>

<script>
import Vue from 'vue'
export default Vue.extend({
  
  data() {
    return {
      flashMessages: {}
    }
  },
  
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if ([ 'addFlashMessage', 'removeFlashMessage' ].includes(mutation.type)) {
        this.flashMessages = { ...state.flashMessages }
      }
    })
  }
})
</script>